module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcBAMAAADy7KARAAAAIVBMVEUAAAD///////////////////////////////////8vIGO9sdh2AAAACnRSTlMAIB9gn6B/gEAQfMw6ggAAAAFiS0dEAf8CLd4AAAAJcEhZcwAAAEgAAABIAEbJaz4AAAB7SURBVBjTldA5DoAgFEXRRyEOFbbuRCuXYk2FrZVLQYxiWKVT1E+MRl9DcrgFASz1JpA5bwYso0EngARkGm/g/kJRvoK7QdD/hY9Pfwb6P/q8kq6iJfgwjB7I2jQ04ZaZkCZSMQOScIsFSCLVClcSWWwQTkfRAnG+n5gBnPI+WjDi95gAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDQtMThUMTE6MzE6MDktMDU6MDCcQUMRAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA0LTE4VDExOjMxOjA5LTA1OjAw7Rz7rQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamBuilding/chart-icon.png
// module id = 620
// module chunks = 0